export default __webpack_public_path__ + "static/media/lc-4.69cb3f4a.JPG";